import { useQuery, queryOptions } from '@tanstack/react-query';

import { STALE_TIMES } from '#lib/queryConstants';

import { listSuggestions, getDailyPlan } from '../../api/crmApi';

import { insightsKeys } from './keys';

export const suggestionsOptions = (filters = {}) =>
	queryOptions({
		queryKey: insightsKeys.suggestions(filters),
		queryFn: async () => {
			const res = await listSuggestions(filters);
			return res.suggestions ?? [];
		},
		staleTime: STALE_TIMES.FREQUENT,
	});

export function useSuggestions(filters = {}, { enabled = true } = {}) {
	return useQuery({ ...suggestionsOptions(filters), enabled });
}

export const dailyPlanOptions = () =>
	queryOptions({
		queryKey: insightsKeys.dailyPlan(),
		queryFn: getDailyPlan,
		staleTime: STALE_TIMES.FREQUENT,
	});

export function useDailyPlan() {
	return useQuery(dailyPlanOptions());
}
